import React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";

const EngageCard = ({ title, image, link, description }) => {
  return (
    <section id={link}>
      <div className="row pt-7 pb-7">
        <div
          className="col-12 col-md-4"
          data-aos="fade-right"
          data-aos-duration="3000"
        >
          <img
            src={`${IMAGE_BASE_URL}/${image}`}
            alt={title}
            className="img-fluid pb-4"
          />
        </div>
        <div
          className="col-12 col-md-8"
          data-aos="fade-left"
          data-aos-duration="3000"
        >
          <div className="ms-0 ms-md-5">
            <h3 className="fs-32">{title}</h3>
            {/* <h4 className="fs-18 gilroy-bold text-orange-ryb pt-4">{title}</h4> */}
            <p
              className="fs-18 lh-2"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {/* <h4 className="fs-18 gilroy-bold text-orange-ryb">How we engage</h4> */}
          </div>
        </div>
      </div>
      <hr />
    </section>
  );
};

export default EngageCard;
